// HRDeva visual token — a square mark with the cyrillic letter «Д».
// Matches the design's `--accent`-on-`--accent-fg` colorway.

export function HRDMark({ size = 22 }: { size?: number }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size >= 18 ? 4 : 3,
        background: "var(--accent)",
        color: "var(--accent-fg)",
        display: "grid",
        placeItems: "center",
        fontFamily: "var(--font-mono)",
        fontWeight: 700,
        fontSize: size <= 14 ? 9 : size <= 18 ? 10 : 11,
        flexShrink: 0,
      }}
    >
      Д
    </div>
  );
}
